import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import { dueTypes } from "../../Config";

const ViewDetailModel = ({ setViewDetail, selectedData }) => {
  // const duesType = (type) => {
  //   if (type === 1) {
  //     return <span>Rent</span>;
  //   } else if (type === 2) {
  //     return <span>Security</span>;
  //   } else if (type === 3) {
  //     return <span>Maintenance</span>;
  //   } else if (type === 4) {
  //     return <span>Electricity</span>;
  //   } else if (type === 5) {
  //     return <span>Registration</span>;
  //   } else if (type === 6) {
  //     return <span>Tech_Changes</span>;
  //   } else if (type === 7) {
  //     return <span>Others</span>;
  //   } else if (type === 8) {
  //     return <span>Agreement Charges</span>;
  //   } else if (type === 9) {
  //     return <span>Food</span>;
  //   } else if (type === 10) {
  //     return <span>Fine</span>;
  //   }
  // };
const duesType = (type) => {
  const found = dueTypes.find((item) => item.value === type);
  return <span>{found ? found.label : "Unknown"}</span>;
};
  return (
    <Model width={`w-11/12 max-w-lg`} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
                    <PropertyId>#{selectedData?.id || "N/A"}</PropertyId>
                </div>

                <Column>
          <FirstColumn>
            <SubHeading>Tenant Id</SubHeading>
            <Paragraph>{selectedData?.tenantId}</Paragraph>
          </FirstColumn>
          <FirstColumn>
            <SubHeading>Property Name</SubHeading>
            <Paragraph>{selectedData?.propName}</Paragraph>
          </FirstColumn>
        </Column>
        <hr />

        <Column>
          <FirstColumn>
            <SubHeading>Client Name</SubHeading>
            <Paragraph>{selectedData?.clientName}</Paragraph>
          </FirstColumn>
          <FirstColumn>
            <SubHeading>Dues Type</SubHeading>
            <Paragraph>{duesType(selectedData?.type)}</Paragraph>
          </FirstColumn>
        </Column>
        <hr />

       

        <Column>
          <FirstColumn>
            <SubHeading>Amount</SubHeading>
            <Paragraph>{selectedData?.amount}</Paragraph>
          </FirstColumn>
          <FirstColumn>
            <SubHeading>Balance</SubHeading>
            <Paragraph>{selectedData?.balance}</Paragraph>
          </FirstColumn>
        </Column>
        <hr />

        <Column>
          <FirstColumn>
            <SubHeading>Dues Date</SubHeading>
            <Paragraph>
              {moment(selectedData?.dueDate).format("DD-MM-YYYY")}
            </Paragraph>
          </FirstColumn>
          <FirstColumn>
            <SubHeading>Created At</SubHeading>
            <Paragraph>
              {moment(selectedData?.createdAt).format("DD-MM-YYYY")}
            </Paragraph>
          </FirstColumn>
        </Column>

        <hr />
        <Column>
          <FirstColumn>
            <SubHeading>Start Date</SubHeading>
            <Paragraph>
              {selectedData?.rentStartDate
    ? moment(selectedData.rentStartDate).format("DD-MM-YYYY")
    : "N/A"}
            </Paragraph>
          </FirstColumn>
          <FirstColumn>
            <SubHeading>End Date</SubHeading>
            <Paragraph>
              {selectedData?.rentEndDate
    ? moment(selectedData.rentEndDate).format("DD-MM-YYYY")
    : "N/A"}
            </Paragraph>
          </FirstColumn>
        </Column>
      </Wrapper>
    </Model>
  );
};

// const SingleItem = ({ name, value }) => (
//   <div className="flex items-center py-2 border-b border-gray-100">
//     <Name>{name}</Name> <p>:</p>
//     {<Value>{value}</Value>}
//   </div>
// );

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const FirstColumn = tw.div``;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;

export default ViewDetailModel;
